"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AlertSnackbar;
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const Alert_1 = __importDefault(require("../Alert"));
function AlertSnackbar({ message, severity, onClose, ...props }) {
    return (react_1.default.createElement(core_1.Snackbar, { anchorOrigin: { vertical: 'top', horizontal: 'center' }, onClose: onClose, ...props },
        react_1.default.createElement(Alert_1.default, { message: message, severity: severity, onClose: onClose })));
}
